// src/features/preorders/pages/PreOrdersPage.tsx

import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  SelectChangeEvent,
} from "@mui/material";
import i18n from "i18next";
import { useAppSelector, useAppDispatch } from "../../../hooks";
import PreOrdersTable from "../components/PreOrdersTable";
import { fetchPreorders } from "../slices/preordersSlice";

const PreOrdersPage = () => {
  const dispatch = useAppDispatch();
  const { loading, error, preorders } = useAppSelector(
    (state) => state.preordersSlice
  );

  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  useEffect(() => {
    dispatch(fetchPreorders());
  }, [dispatch]);



  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const handleStatusChange = (event: SelectChangeEvent<string>) => {
    setStatusFilter(event.target.value as string);
  };

  const filteredPreorders = Array.isArray(preorders)
  ? preorders.filter((preorder) => {
      const matchesSearchTerm = Object.values(preorder).some((value) =>
        value
          ? value.toString().toLowerCase().includes(searchTerm.toLowerCase())
          : false
      );
      const matchesStatus = statusFilter
        ? preorder.STATUSCOMMANDE === statusFilter
        : true;

      return matchesSearchTerm && matchesStatus;
    })
  : [];

  


  return (
    <Box >
      <Typography variant="h5">{i18n.t("preOrders.title")}</Typography>
      <Grid
        container
        sx={{
          py: 3,
          px: 2,
          mt: 2,
          borderRadius: "12px",
          border: "1px solid #E8EBFD",
          display: "flex",
          flexDirection: "row",
        }}
      >
        <Grid item sx={{ width: "100%" }}>
          <Grid container columnGap={2}>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                label="Recherche"
                variant="outlined"
                fullWidth
                value={searchTerm}
                onChange={handleSearchChange}
                sx={{ mb: 2 }}
              />
          
            </Grid>
            <Grid item xs={12} sm={12} md>
            <FormControl fullWidth variant="outlined" sx={{ mb: 3 }}>
                <InputLabel>Status</InputLabel>
                <Select
                  value={statusFilter}
                  onChange={handleStatusChange}
                  label="Status"
                >
                  <MenuItem value="">
                    <em>Tous</em>
                  </MenuItem>
                  <MenuItem value="Created">Created</MenuItem>
                  <MenuItem value="Validated ">Validated</MenuItem>
                  <MenuItem value="Pending">Pending</MenuItem>
                  <MenuItem value="Canceled">Canceled</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
        <Grid item sx={{ width: "100%" }}>
          {loading ? (
            <Typography>Loading...</Typography>
          ) : error ? (
            <Typography color="error">{error}</Typography>
          ) : (
            <PreOrdersTable rows={filteredPreorders} />
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default PreOrdersPage;
